const HUBSPOT_PORTAL_ID = "9187193";

export const hubspotDealUrl = (dealId: string | number) =>
  `https://app.hubspot.com/contacts/${HUBSPOT_PORTAL_ID}/record/0-3/${dealId}`;

export const hubspotQuoteUrl = (quoteId: string | number) =>
  `https://app.hubspot.com/quotes/${HUBSPOT_PORTAL_ID}/details/${quoteId}`;
